<template>
    <div>
        {{ msg }}
    </div>
</template>

<script>
export default {
    name: "Dashboard",
    data() {
        return {
            msg: 'Dashboard Here',
        }
    },
}
</script>

<style scoped>

</style>
